import type { ReactElement } from "react";

/**
 * Chrome-style base corner for the active tab (PB-5176 d11): the tab flares
 * INTO the baseline through a concave 8px curve instead of meeting it at a
 * right angle. Drawn as an SVG so the fill and the 1px edge use design-system
 * tokens (`fill-pb-card-elevated`, `stroke-pb-border`) rather than an
 * arbitrary gradient class; the outer half of the arc's stroke continues the
 * tab's own side border down to the baseline. `start`/`end` follow the writing
 * direction and the arc mirrors under RTL.
 */
export function TabBaseFlare({
  side,
}: {
  readonly side: "start" | "end";
}): ReactElement {
  const arc = side === "start" ? "M8 0A8 8 0 0 1 0 8" : "M0 0A8 8 0 0 0 8 8";
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 8 8"
      data-tab-flare={side}
      className={`pointer-events-none absolute bottom-0 h-2 w-2 fill-pb-card-elevated stroke-pb-border rtl:-scale-x-100 ${
        side === "start" ? "-start-2" : "-end-2"
      }`}
    >
      <path d={`${arc}L${side === "start" ? 8 : 0} 8Z`} strokeWidth="0" />
      <path d={arc} fill="none" strokeWidth="1" />
    </svg>
  );
}
